<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem2" />
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <!-- <img :src="importedImg4" alt="" class="imgItem4" /> -->
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <!-- <img :src="importedImg5" alt="" class="imgItem5" /> -->
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <!-- <img :src="importedImg6" alt="" class="imgItem6" /> -->
        <p>คุณสมบัติของเรา</p>
        <div class="imgWrapper">
          <img :src="imported4Img1" alt="" class="imgItem6" />
          <img :src="imported4Img2" alt="" class="imgItem6" />
          <img :src="imported4Img3" alt="" class="imgItem6" />
          <img :src="imported4Img4" alt="" class="imgItem6" />
          <img :src="imported4Img5" alt="" class="imgItem6" />

          <img :src="imported4Img1" alt="" class="imgItem6" />
          <img :src="imported4Img2" alt="" class="imgItem6" />
          <img :src="imported4Img3" alt="" class="imgItem6" />
          <img :src="imported4Img4" alt="" class="imgItem6" />
          <img :src="imported4Img5" alt="" class="imgItem6" />
        </div>
      </div>
    </div>
    <!-- <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <img :src="importedImg7" alt="" class="imgItem7" />
      </div>
    </div> -->
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/growmoney/components/img/2_1.png";
import importedImg2 from "@/page/growmoney/components/img/2_2.png";
import importedImg3 from "@/page/growmoney/components/img/2_3.png";
import imported4Img1 from "@/page/growmoney/components/img/2_4_1.png";
import imported4Img2 from "@/page/growmoney/components/img/2_4_2.png";
import imported4Img3 from "@/page/growmoney/components/img/2_4_3.png";
import imported4Img4 from "@/page/growmoney/components/img/2_4_4.png";
import imported4Img5 from "@/page/growmoney/components/img/2_4_5.png";
// import importedImg4 from "@/page/growmoney/components/img/2_4.png";
// import importedImg5 from "@/page/growmoney/components/img/2_5.png";
// import importedImg6 from "@/page/growmoney/components/img/2_6.png";
// import importedImg7 from "@/page/growmoney/components/img/2_7.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      // importedImg4: importedImg4,
      // importedImg5: importedImg5,
      // importedImg6: importedImg6,
      // importedImg7: importedImg7,
      imported4Img1:imported4Img1,
      imported4Img2:imported4Img2,
      imported4Img3:imported4Img3,
      imported4Img4:imported4Img4,
      imported4Img5:imported4Img5,
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}
img {
  display: block;
}
.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}

.img1Box {
  padding:  200px;
}

.img3Box {
 padding:200px 200px 20px;
}


/* 容器最大宽度 */
.img6Box {
  width: 100%;
  overflow: hidden;
  position: relative; /* 定位容器 */
}
.img6Box p{
  text-align: center;
  font-size: 48px;
  font-weight: bold;
  margin-top: 50px;
  font-family: PT Sans, sans-serif;
}

/* 包裹图片的外层容器 */
.imgWrapper {
  display: flex; /* 横向排列图片 */
  animation: moveImages 25s linear infinite;
  /* 动画控制，15s 为动画周期，线性平滑过渡，永远循环 */
  height: 400px;
}

/* 每张图片的样式 */
.imgItem6 {
  width: 450px;
  height: 300px; /* 图片的高度可以根据需求调整 */
  margin-right: 30px; /* 图片之间的间距 */
  margin-top: 40px;
  /* animation: moveImages 36s linear infinite; */
}
.imgItem6 img{
  width: 100%;
  height: 100%;
}
.imgItem6:hover {
  /* box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);  */
  /* 8px的垂直偏移，15px的模糊半径，30%透明度的黑色阴影 */
}
/* .imgItem6:nth-child(2n) {
  margin-top: 110px;
} */

/* 关键帧动画：让图片从右往左移动 */
@keyframes moveImages {
  0% {
    transform: translateX(0); /* 起始位置 */
  }
  100% {
    transform: translateX(-2030px); /* 最终位置，6张图片，每张600px，移动 6*600px */
  }
}
</style>
